import { render } from "./Objekttyp.vue?vue&type=template&id=08f00319"
import script from "./Objekttyp.vue?vue&type=script&lang=js"
export * from "./Objekttyp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__